module.exports = __webpack_public_path__ + "static/media/software.5a164f18.webp";